import axios from 'axios'

export default class ApiManager {
    /**
   * Get series of customer
   */
    static async getSeries(userId) {
        return axios.get(`/back-office/series_customers/${userId}/getAllAvailableSeries`).then(res => {
            return res.data
        })
    }

    /**
   * Get treatments of customer
   */
    static async getTreatments(userId) {
        return axios.get(`/back-office/treatments_customers/${userId}/getAllAvailableTreatments`).then(res => {
            return res.data
        })
    }

    static async getPromoCode(codeId) {
        return axios.get(`/back-office/promotion/get/code/${codeId}`).then(res => {
            return res.data
        })
    }

    static async editSeller(rowId, sellerId, adviserId) {
        return axios.post(`/back-office/caisse/edit/seller/${rowId}`, { type: "staff", seller_id: sellerId, advised_id: adviserId }).then(res => {
            return res.data
        })
    }

    static async getAllStaffs() {
        return axios.get(`/back-office/caisse/getAllStaffs`).then(res => {
            return res.data
        })
    }

    static async getItemCategory(itemId, type) {
        return axios.post(`/back-office/caisse/getItemCategory/${itemId}`, {type: type})
    }

    // static async applyPromotionToCart(rowId, discountAmount, discountType) {
    //     return axios.post(`/back-office/promotion/apply/cart/${rowId}`, {discountAmount: discountAmount, discountType: discountType})
    // }
}